'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { allowDarkMode } from '@/utils/common-helpers';

export default function ThemeToggle() {
    const pathname = usePathname();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    // Don't render anything until mounted to prevent hydration mismatch
    if (!mounted) return null;

    // Only show toggle on AI/ML page
    if (!allowDarkMode(pathname)) return null;

    // Dark mode is now handled by FlowbiteContext and layout script
    // This component can be used for additional theme toggle UI if needed
    return <div className="flex items-center">{/* <DarkThemeToggle /> */}</div>;
}
